import * as React from 'react'
import { SaveButton, Toolbar } from 'react-admin'

export const SaveOnlyToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
)
